module.exports = __webpack_public_path__ + "static/img/p-32.5f23164.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-32.png
// module id = dTnJ
// module chunks = 0